<template>
  <div>
    <transition-group
      name="list"
      tag="div"
      class="mt-8 grid gap-5 max-w-lg mx-auto md:grid-cols-2 lg:grid-cols-3 md:max-w-none"
    >
      <div
        v-for="(job, i) in jobs"
        v-bind:key="`${job.companyName}_${i}`"
        class="flex flex-col rounded-lg shadow-lg overflow-hidden cursor-pointer"
        v-on:click="(e) => openModal(e, job)"
      >
        <img
          class="h-48 w-full object-cover"
          v-bind:src="
            job.screenshotUrl ||
              `https://source.unsplash.com/400x225/?${job.tags.join(',')}`
          "
          v-bind:alt="job.companyName"
        />

        <div class="flex-1 bg-white p-6 flex flex-col justify-between">
          <div class="flex-1">
            <p class="text-sm leading-5 font-medium text-indigo-600">
              {{ job.companyName }}
            </p>

            <h3 class="mt-2 text-xl leading-7 font-semibold text-gray-900">
              {{ job.position }}
            </h3>

            <div class="max-h-32 overflow-hidden">
              <p
                class="mt-3 text-base leading-6 text-gray-500"
                v-html="marked(job.description)"
                v-if="job.source === 'remoteok.io'"
              ></p>
              <p
                v-else
                class="mt-3 text-base leading-6 text-gray-500"
                v-html="job.description"
              ></p>
            </div>
          </div>
          <div class="mt-2 flex flex-wrap">
            <span
              class="inline-block mb-1 mr-1 cursor-pointer px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-green-100 text-green-800"
              >{{ job.source }}</span
            >
            <span
              v-for="(tag, i) in job.tags"
              v-bind:key="`${job.company}_${job.position}_${tag}_${i}`"
              class="tag inline-block mb-1 mr-1 cursor-pointer px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-indigo-100 text-indigo-800"
              v-on:click="addFilterTag(tag)"
              >{{ tag }}</span
            >
          </div>
          <div class="mt-6 flex items-center">
            <div class="flex-shrink-0 mr-3" v-if="job.companyLogoUrl">
              <img
                class="h-10 w-10 rounded-full object-cover"
                :src="job.companyLogoUrl"
                :alt="job.companyName"
              />
            </div>
            <div>
              <div class="flex text-sm leading-5 text-gray-500">
                <time datetime="2020-03-16">{{
                  job.date | diffForHumans
                }}</time>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

export default {
  name: 'JobCards',
  props: {
    jobs: Array,
    openModal: Function,
  },
  created() {
    dayjs.extend(relativeTime);
  },
  filters: {
    diffForHumans: (date) => {
      if (!date) {
        return null;
      }

      return dayjs(date).fromNow();
    },
  },
};
</script>
<style scoped>
ul,
li {
  margin: 0;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.4s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(25px);
}
</style>
